import React from 'react'
import Modal from 'react-modal'
import styles from './uploader.scss'
import nesProp from 'nested-property'
import { Table, Thead, Th, Tr, Td, collapseTd } from 'components/reactable'
import moment from 'moment'
import { fetchUploadTarifications, fetchOneTarificationDataForIndexMap } from 'state/actions'
import c from 'state/constants'
import cs from 'classnames'
import i18n from 'lib/i18n'

const _ = i18n('uploader')

const customStyles = {
    overlay: {
        position: 'fixed',
        top: 0, left: 0, right: 0, bottom: 0,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: 'rgba(255, 255, 255, 0.75)',
        overflow: 'visible'
    },
    content: {
        width: '600px',
        position: 'relative',
        top: 'initial', bottom: 'initial', left: 'initial', right: 'initial',
        maxHeight: '90%',
        //minHeight: '50%',
        overflow: 'auto',
        padding: '0',
        wordWrap: "break-word"
    },
}

/**
 * This component will handle tarification documents selection for linking with a contract and upload at the contract level
 */
export default class TarificationSelectionModal extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            clientTarificationsList: [],
            tarificationDetailsList: {},
            isOpened: {},
            selectedDocuments: []
        }
    }

    /**
     * Used to open/close one tarification details
     * @param {*} tarificationNumber 
     */
    async onTarificationDetailsClick(tarificationId) {
        const { tarificationDetailsList } = this.state
        const { dispatch, modalIsOpen } = this.props
        const openedTarificationDetailsListClone = structuredClone(tarificationDetailsList)
        const indexTypes = modalIsOpen
        if (!tarificationDetailsList || !tarificationDetailsList[tarificationId]) {
            const getTarificationData = await dispatch(fetchOneTarificationDataForIndexMap(tarificationId, indexTypes))
            openedTarificationDetailsListClone[tarificationId] = getTarificationData
        }

        this.setState({
            isOpened: { ...this.state.isOpened, [tarificationId]: !this.state.isOpened[tarificationId] },
            tarificationDetailsList: openedTarificationDetailsListClone
        })
    }

    /**
     * Handle document selection
     * @param {*} ev 
     * @param {*} document 
     */
    onselectDocument(ev, document) {
        const { selectedDocuments } = this.state
        const clonedDocuments = structuredClone(selectedDocuments)
        const index = clonedDocuments.findIndex(oneDoc => oneDoc.tarificationDocId === document.tarificationDocId)
        if (index > -1) {
            clonedDocuments.splice(index, 1)
        } else {
            clonedDocuments.push(document)
        }

        this.setState({ selectedDocuments: clonedDocuments })
    }

    /**
     * Sends selected documents to parent component
     * @returns 
     */
    handleOnNextClick() {
        const { modalIsOpen, method } = this.props
        const { selectedDocuments } = this.state
        const documentsForNextStep = structuredClone(selectedDocuments)
        if (documentsForNextStep && modalIsOpen && documentsForNextStep.length) {
            this.setState({
                clientTarificationsList: [],
                selectedDocuments: [],
                tarificationDetailsList: {},
                isOpened: {},
            })
            method(documentsForNextStep)
        }
        return
    }

    render() {
        const { isOpened, tarificationDetailsList, selectedDocuments } = this.state
        const { modalIsOpen, onCancel, clientTarificationsList, payload, method } = this.props
        return (
            <div>
                <Modal
                    isOpen={modalIsOpen && modalIsOpen.length > 0}
                    onCancel={onCancel}
                    style={customStyles}
                    className={styles.modal}
                    contentLabel={""}
                >
                    <div className={styles.title}>{_('tarificationSelectionModalTitle')}</div>

                    <div className={styles.contentWrapper}>
                        <Table
                            onVisibleChange={this.handleVisibleList}
                            filterable={[
                                "tarificationNumber"
                            ]}
                            ref={el => { this.table = el }}
                            id="table"
                            className="table"
                            sortable={[
                                'tarificationNumber',
                            ]}
                            defaultSort={{
                                column: 'tarificationNumber',
                                direction: 'desc',
                            }}

                            itemsPerPage={50}
                            pageButtonLimit={5}
                        >
                            <Thead>
                                <Th column="collapse" label="" />
                                <Th column="tarificationNumber">
                                    <strong>{_("tarificationNumber")}</strong>
                                </Th>
                            </Thead>
                            {clientTarificationsList && clientTarificationsList.length && clientTarificationsList.length > 0 ?
                                clientTarificationsList.map((item, key) =>
                                    <Tr
                                        className={`clickable`}
                                        i={item}
                                        key={key}
                                        onClick={() => {
                                            this.onTarificationDetailsClick(item.tarificationMain.tarificationId)
                                        }}
                                    >
                                        {collapseTd({
                                            column: 'collapse',
                                            isOpened: isOpened[item.tarificationMain.tarificationId],
                                            children: (
                                                <div className={styles.content}>
                                                    <h2 className={styles.tarificationDocumentsTitle}>{_('tarificationDocuments')}</h2>
                                                    <div key={"TdDetailsKey"}>
                                                        {tarificationDetailsList && tarificationDetailsList[item.tarificationMain.tarificationId] && tarificationDetailsList[item.tarificationMain.tarificationId].tarificationDocuments
                                                            && tarificationDetailsList[item.tarificationMain.tarificationId].tarificationDocuments.length > 0 ?
                                                            <ul>
                                                                {
                                                                    tarificationDetailsList[item.tarificationMain.tarificationId].tarificationDocuments.map((oneDoc, key) => {
                                                                        return (
                                                                            <li key={key + 'tarifiactionDocList'} className={styles.tarificationDocumentListElem}>
                                                                                <div className={styles.tarificationDocumentListElemInput}>
                                                                                    <input
                                                                                        type="checkbox"
                                                                                        onClick={ev => ev.stopPropagation()}
                                                                                        onChange={ev => this.onselectDocument(ev, oneDoc)}
                                                                                        checked={selectedDocuments.findIndex(e => e.tarificationDocId === oneDoc.tarificationDocId) > -1 ? true : false}
                                                                                        disabled={selectedDocuments && selectedDocuments.length && selectedDocuments.findIndex(e => e.tarificationDocId === oneDoc.tarificationDocId) < 0}
                                                                                    />
                                                                                </div>
                                                                                <div className={styles.tariffInputLabelWrapper}>
                                                                                    <img src={require('resources/images/pdf-icon_1x.png')}
                                                                                        onClick={ev => {
                                                                                            ev.stopPropagation()
                                                                                            window.open(`/data/document?id=${oneDoc.tarificationDocId}&docType=${encodeURI(oneDoc.tarificationDocType)}&uploadDate=${encodeURI(oneDoc.tarificationDocDate)}`, '_blank' , 'noopener,noreferrer')
                                                                                        }}
                                                                                    />
                                                                                    <p>{oneDoc.tarificationDocType} {moment(oneDoc.tarificationDocDate).format('DD-MM-YYYY')}</p>
                                                                                </div>

                                                                            </li>
                                                                        )
                                                                    })
                                                                }
                                                            </ul>
                                                            :
                                                            _('tarificationNoDocumentsMessage')
                                                        }
                                                    </div>
                                                </div>
                                            )
                                        })}
                                        <Td column="tarificationNumber" value={item.tarificationMain.tarificationNumber}>{item.tarificationMain.tarificationNumber}</Td>
                                    </Tr>

                                ) : ''
                            }
                        </Table>
                        <div className={styles.buttons}>
                            <div
                                onClick={() => {
                                    this.setState({
                                        clientTarificationsList: [],
                                        tarificationDetailsList: {},
                                        isOpened: {},
                                    })
                                    onCancel()
                                }}
                                className={cs(styles.cancel)}
                            >
                                {_('cancel')}
                            </div>

                            <div
                                onClick={() => this.handleOnNextClick()}
                                className={cs(styles.next, selectedDocuments && modalIsOpen && selectedDocuments.length ? styles.enabled : styles.disabled)}
                            >
                                {_("ok")}
                            </div>
                        </div>
                    </div>
                </Modal>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./components/uploader/tarificationSelectionModal.jsx